/**
 * Облик героя: три фигуры на выбор, чистая косметика.
 *
 * Назначение файла: держит список обликов и разбор значения из настроек. Облик
 * не влияет ни на один стат и ни на одно правило игры (закон 9), поэтому живёт
 * в клиенте и не спрашивает сервер.
 */

export type HeroAppearanceId = "bee" | "keeper" | "warden";

export interface HeroAppearance {
  readonly id: HeroAppearanceId;
  /** Фигура в полный рост для экрана героя. */
  readonly figure: string;
  /** Квадратный кадр по голове: шапка профиля и выбор облика. */
  readonly avatar: string;
}

/**
 * Файлы лежат в `public/art` и раздаются как статика: сборщик их не трогает,
 * первый экран не ждёт их загрузки.
 */
export const HERO_APPEARANCES: readonly HeroAppearance[] = [
  {
    id: "bee",
    figure: "/art/hero-bee.webp",
    avatar: "/art/hero-bee-avatar.webp",
  },
  {
    id: "keeper",
    figure: "/art/hero-keeper.webp",
    avatar: "/art/hero-keeper-avatar.webp",
  },
  {
    id: "warden",
    figure: "/art/hero-warden.webp",
    avatar: "/art/hero-warden-avatar.webp",
  },
];

export const DEFAULT_HERO_APPEARANCE: HeroAppearanceId = "bee";

/** Неизвестное значение в настройках — не ошибка: облик становится обликом по умолчанию. */
export function parseHeroAppearance(value: string | null): HeroAppearanceId {
  const found = HERO_APPEARANCES.find((appearance) => appearance.id === value);
  return found?.id ?? DEFAULT_HERO_APPEARANCE;
}

export function heroAppearance(id: HeroAppearanceId): HeroAppearance {
  const found = HERO_APPEARANCES.find((appearance) => appearance.id === id);
  return found ?? HERO_APPEARANCES[0]!;
}
